import EDPConfirmRsvpModal from 'components/GlobalModals/EDPConfirmRsvpModal/EDPConfirmRsvpModal';

export default EDPConfirmRsvpModal;
